import { toast } from 'react-toastify';

export default class Toast {
  static success(message) {
    return toast.success(message, this.config(message));
  }

  static error(message) {
    console.log('HH:', message);
    return toast.error(message, this.config(message));
  }

  static info(message) {
    return toast.info(message, this.config(message));
  }

  static warn(message) {
    return toast.warn(message, this.config(message));
  }

  static isActive(toastId) {
    return toast.isActive(toastId);
  }

  static config(message) {
    const config = {};
    config.autoClose = Math.min(Math.max(50 * message.length, 2000), 7000);
    return { ...config };
  }
}
